import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { ASSIGNMENTS_QUERIES } from "~/shared/api/assignments/assignments.queries";
import { notFound } from "~/shared/util/notFound";

export function assignmentViewLoader({ params }: LoaderFunctionArgs, queryClient: QueryClient) {
  const { assignmentId } = params;

  if (!assignmentId) {
    return notFound();
  }

  queryClient.prefetchQuery(ASSIGNMENTS_QUERIES.user.detail(assignmentId));

  return null;
}
